import React, { FC, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Image } from 'react-native-elements/dist/image/Image';
import ChatWidget from './ChatWidget';

interface ChatImageItemProps {
  title?: string;
  description?: string;
  imageSource: string;
}

const ChatImageItem: FC<ChatImageItemProps> = (props) => {
  const [aspectRatio, setAspectRatio] = useState(1); // Default aspect ratio

  useEffect(() => {
    // Dynamically fetch image dimensions to calculate aspect ratio
    Image.getSize(props.imageSource, (width, height) => {
      setAspectRatio(width / height);
    });
  }, [props.imageSource]);

  return (
    <ChatWidget>
      <Image
        style={[styles.image, { aspectRatio }]}
        source={{ uri: props.imageSource }}
        resizeMode="contain"
      />
    </ChatWidget>
  );
};

// Styles
const styles = StyleSheet.create({
  image: {
    width: '100%',
    borderRadius: 15,
  },
});

export default ChatImageItem;
